<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="ap-modal-title-big">
            Сведения о проекте
        </div>
        <DataEntryFieldProject @apply="apply" :projectData="projectData"/>
    </div>
</template>

<script>
import SVGModalClose from "../../../SVG/SVGModalClose";
import DataEntryFieldProject from "./DataEntryFieldProject";

export default {
name: "EditProject",
    components: {DataEntryFieldProject, SVGModalClose},
    props:{
        projectData:{
            type: Object
        }
    },
    methods: {
        async apply(newData) {
            await this.$store.dispatch('adminPanel/projects/SAVE_PROJECT', newData);
            this.$emit('close');
        }
    }
}
</script>

<style scoped>

</style>
